// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import moveIcon from "@/assets/icons/move.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MoveIconProps = Omit<IconProps, "name">;

export function MoveIcon(props: MoveIconProps): React.ReactNode {
  return <Icon name={moveIcon} {...props} />;
}
